import React, { useId } from 'react';
import { cn } from './cn';

/** Label dùng chung. */
export function Label({ className, children, required = false, ...props }) {
  return (
    <label className={cn('block text-sm font-medium text-heading mb-2', className)} {...props}>
      {children}
      {required ? <span className="text-red-500 ml-0.5">*</span> : null}
    </label>
  );
}

/**
 * FormField — bọc label + control + helper/error.
 * Truyền `htmlFor`/`id` để gắn label đúng control. Không truyền thì TỰ gắn: nhãn trỏ vào id sinh sẵn của ô con duy nhất
 * (bản cũ phần lớn form không gắn nên bấm nhãn không focus được ô, trình đọc màn hình đọc ô trống không tên).
 */
export function FormField({ label, htmlFor, required, error, helper, className, children }) {
  const autoId = useId().replace(/:/g, '');
  let controlId = htmlFor;
  let content = children;
  if (!controlId && label && React.isValidElement(children) && typeof children.type !== 'string' && children.type !== React.Fragment) {
    // Ô con duy nhất là component (Input, Select, ComboSelect...): cấp id nếu nó chưa có.
    controlId = children.props.id || `ff-${autoId}`;
    if (!children.props.id) content = React.cloneElement(children, { id: controlId });
  }
  return (
    <div className={cn('w-full', className)}>
      {label ? (
        <Label htmlFor={controlId} required={required}>
          {label}
        </Label>
      ) : null}
      {content}
      {error ? (
        <p className="mt-1.5 text-sm text-red-600 dark:text-red-400">{error}</p>
      ) : helper ? (
        <p className="mt-1.5 text-sm text-muted">{helper}</p>
      ) : null}
    </div>
  );
}

export default FormField;
